import { HighLowChart } from '@toggle/design-system';
import React, { RefObject } from 'react';
import { useTranslation } from 'react-i18next';

import { ScenariosData } from '~/react-query-hooks/scenarios/useScenarios';
import { ChartLegend } from '~/views/dashboard/calendar-widget/calendar-event-drawer/drawer-content/earnings-event-drawer-content/earnings-chart/chart-legend/ChartLegend';

import * as S from './EpsExpectationsSection.styles';

export interface HighLowMedianDataPoint {
  high: number;
  low: number;
  median: number;
  label?: string;
}

export interface WhatIfChartProps {
  entityName: string;
  scenariosData: ScenariosData[];
  activeButtonLabel: string;
  handleDigIntoData: () => void;
  chartWrapperRef: RefObject<HTMLDivElement | null>;
  mappedScenariosData: HighLowMedianDataPoint[];
  width: number;
  chartHeight: number;
}

export const WhatIfChart = ({
  entityName,
  scenariosData,
  activeButtonLabel,
  handleDigIntoData,
  chartWrapperRef,
  mappedScenariosData,
  width,
  chartHeight,
}: WhatIfChartProps) => {
  const { t } = useTranslation(['earnings', 'whatsNew']);

  return (
    <>
      <S.FlexRow>
        <S.ChartTitleLabel>
          {t(
            'earnings:earningsInsight.drawer.earningsPreview.stockPerformanceAfterEarnings',
            {
              name: entityName,
              count: scenariosData[0]?.episodes?.length,
              expectation: activeButtonLabel,
            }
          )}
        </S.ChartTitleLabel>
        <S.StyledButton
          label={t(
            'earnings:earningsInsight.drawer.earningsPreview.digIntoTheData'
          )}
          variant="empty"
          onClick={handleDigIntoData}
        />
      </S.FlexRow>
      <ChartLegend />
      <S.ChartWrapper ref={chartWrapperRef} data-testid="chart-container">
        <HighLowChart
          data={mappedScenariosData}
          width={width}
          height={chartHeight}
          variant="secondary"
        />
      </S.ChartWrapper>
    </>
  );
};
